import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

export default {
  getOrderList(params) { //获取订单列表
    const url =  baseURL + '/tbOrder/getList';
    return axios.post(url, qs.stringify(params));
  },
  addOrder(params) { //新增订单
    const url =  baseURL + '/tbOrder/addOrder';
    return axios.post(url, qs.stringify(params));
  },
  detailOrder(params) { //订单详情
    const url =  baseURL + '/tbOrder/getDetail';
    return axios.post(url, qs.stringify(params));
  },
  // delOrder(params) { //订单撤销
  //   const url =  baseURL + '/tbOrder/delete';
  //   return axios.post(url, qs.stringify(params));
  // },

  delOrder(params) { //订单撤销
    const url =  baseURL + '/tbOrder/deleteBeginAuth';
    return axios.post(url, qs.stringify(params));
  },

  verifyOrder(params) { //订单审核
    const url =  baseURL + '/tbOrder/examineOrder';
    return axios.post(url, qs.stringify(params));
  },
  
  // 订单中产品续订
  renewOrder(params) { 
    const url =  baseURL + '/tbOrder/renewOrderAuPro';
    return axios.post(url, qs.stringify(params));
  },


  
}


// WEBPACK FOOTER //
// ./src/api/order.js